import { observer } from 'mobx-react-lite';
import * as React from 'react';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { PersonaSize } from '@fluentui/react/lib/Persona';

import styles from './GroupView.scss';

export interface GroupViewProps {
    itemIndex: number;
    isSelected: boolean;
    groupSmtpEmailAddress: string;
    primaryText: string;
    ariaLabel: string;
    secondaryText?: string;
    className?: string;
    onSelectedClassName?: string;
}

export default observer(function GroupView(props: GroupViewProps) {
    React.useEffect(() => {
        if (props.itemIndex === 0) {
            focus();
        }
    }, []);
    const groupContainer = React.useRef<HTMLDivElement>();
    const focus = () => {
        groupContainer.current.focus();
    };
    const focusOnGroupViewOnMouseDown = (evt: React.MouseEvent<unknown>) => {
        // If a click happens on the child container then we need to change the focus
        // back to the parent container of the group view.
        evt.stopPropagation();
        evt.preventDefault();
        focus();
    };
    return (
        <div
            className={styles.groupContainer}
            ref={ref => (groupContainer.current = ref)}
            onMouseDown={focusOnGroupViewOnMouseDown}
            aria-label={props.ariaLabel}
            data-is-focusable={true}
            tabIndex={-1}
            data-selection-invoke={true}
            data-selection-index={props.itemIndex}
            title={props.primaryText}>
            <div className={styles.iconContainer}>
                <PersonaControl
                    emailAddress={props.groupSmtpEmailAddress}
                    name={props.primaryText}
                    size={PersonaSize.size48}
                    showPersonaDetails={false}
                    mailboxType={'GroupMailbox'}
                />
            </div>
            <div className={styles.infoContainer}>
                <div className={styles.width100percentForEllipsis}>
                    <div className={styles.primaryText}>{props.primaryText}</div>
                    <div className={styles.secondaryText}>{props.secondaryText}</div>
                </div>
            </div>
        </div>
    );
});
